import { AnalyticsFeatures } from '../../AnalyticsFeatures';
import { defaultClusterName } from '../../../../../../app.constants';
export const isShowDataExtractor = async () => {
    const dataExtractorShowInClusters = await AnalyticsFeatures.dataExtractorShowTab();
    const currentClusterName = defaultClusterName.toLowerCase();
    const clusterToUse = currentClusterName in dataExtractorShowInClusters ? currentClusterName : 'default';
    const dataForThisCluster = dataExtractorShowInClusters[clusterToUse];
    const isEnabled = dataForThisCluster['isEnabled'];
    return isEnabled;
};
